<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      shouldShow: true
    };
  },

  methods: {
    ...mapActions("payable", ["resetPayment"]),

    async returnToPayment() {
      this.shouldShow = false;

      await this.resetPayment();
    }
  },

  computed: {
    ...mapState("payable", ["errorMessageOnPayment"]),

    customErrorMessage: function() {
      return (
        this.errorMessageOnPayment &&
        typeof this.errorMessageOnPayment === "object" &&
        this.errorMessageOnPayment.title
      );
    },

    shouldBlockPayment: function() {
      return (
        this.errorMessageOnPayment &&
        this.errorMessageOnPayment.shouldBlockPayment
      );
    }
  }
};
</script>

<template>
  <div v-if="shouldShow">
    <img src="/static/icon-error.svg" alt="TIVEMOS UM PROBLEMA :(">

    <h3>TIVEMOS UM PROBLEMA :(</h3>

    <div class="error-message">
      <span  v-if="!customErrorMessage">Seu pagamento não pode ser processado. Verifique os dados informados(número do cartão, cvv, cpf/cnpj, dentre outros) e tente novamente.</span>

      <template v-else>
        <span class="title">{{ errorMessageOnPayment.title }}</span>
        <span class="subtitle" v-if="errorMessageOnPayment.subtitle">
          {{ errorMessageOnPayment.subtitle }}
        </span>

        <span class="sugestion" v-if="errorMessageOnPayment.sugestion">
          *{{ errorMessageOnPayment.sugestion }}
        </span>
      </template>
    </div>

    <button
      class="btn bg-pink"
      @click="returnToPayment"
      v-if="!shouldBlockPayment"
    >
      Voltar para tentar novamente
    </button>
  </div>
</template>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #424242;
}

img {
  width: 75px;
  height: 75px;
}

span {
  text-align: center;
}

.error-message {
  width: 100%;
  padding: 16px;
  background: #efefef;
}

.title {
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  margin-bottom: 0;
}

.subtitle {
  font-size: 12px;
  margin-top: 8px;
  font-weight: 300;
}

.sugestion {
  margin-top: 16px;
  color: var(--purple);
  font-weight: 400;
  font-size: 14px;
  text-align: justify;
}

button {
  margin: 0;
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/Components/Error.vue